import numeral from "numeral";
import React from "react";
import "./index.css";

const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
        const values = payload.map(row => {
            let value = row.payload[row.dataKey];

            if(row.dataKey === 'requests' || row.dataKey === 'responses') value = numeral(value).format('0.000a');

            return <p key={row.dataKey} style={{ color: row.stroke }}>{row.dataKey}: <strong>{value}</strong></p>;
        })

        return (
            <div className="g-custom-tooltip" style={{ background: '#fff'}}>
                <p>{label}</p>
                {values}
            </div>
        );
    }

    return null;
};

export default CustomTooltip;


// WEBPACK FOOTER //
// ./src/scenes/BidderSourcesGraph/components/Graph/components/CustomTooltip/index.js